<template>
  <footer class="bg-footer text-gray-50 lg:pl-24">
      <div class="lg:flex py-6 px-8 lg:px-0 lg:space-x-20 border-b border-fborder overflow-hidden">
            <div class="w-full lg:w-1/4 py-4 lg:py-0">
                <img src="../assets/img/logo-white.svg" class="w-48">
                <h3 class="text-xs py-2 text-gray-300 leading-5">रोजगारी सर्भिसेस प्रा.लि.द्धारा संचालित रोजगारी पसलले बिगत ७ वर्षदेखि विभिन्न क्षेत्रमा स्वदेशी रोजगारी सेवा प्रदान गर्दै आइरहेको छ । सिपमुलक काम खोजिरहेका व्यक्तिहरुलाई विभिन्न संघ–संस्थाहरुमा लगाइदिने उद्देश्य लिएर यस पसलको स्थापना भएको हो.. <a href="#" class="text-blue-600 ml-2">अधिक हेर्नुहोस्</a></h3>
            </div>
                <div class="flex space-x-20">
                    <div class="">
                        <h2 class="text-lg">सर्वाधिक लोकप्रिय</h2>
                        <h3 class="text-sm mt-2 text-gray-400">गृह पृष्ठ</h3>
                        <h3 class="text-sm text-gray-400">खाता खोल्नुहोस</h3>
                        <h3 class="text-sm text-gray-400">नियम र सर्त</h3>
                        <h3 class="text-sm text-gray-400">हाम्रोबारे</h3>
                        <h3 class="text-sm text-gray-400">रोजगारी मुलक जानकारी</h3>
                    </div>
                    <div class="">
                        <h2 class="text-lg">रोजगार खोजीकर्ता </h2>
                        <h3 class="text-sm mt-2 text-gray-400">लगईन गर्नुहोस्</h3>
                        <h3 class="text-sm text-gray-400">खाता खोल्नुहोस</h3>
                        <h3 class="text-sm text-gray-400">काम खोज्नुहोस्</h3>
                        <h3 class="text-sm text-gray-400">रोजगारीमुखी तालिम</h3>
                        <h3 class="text-sm text-gray-400">व्यवसाय</h3>
                    </div>
                </div>
                <div class="flex space-x-20 mt-6 lg:mt-0">
                    <div class="">
                        <h2 class="text-lg">रोजगारदाता  </h2>
                        <h3 class="text-sm mt-2 text-gray-400">कामको विवरण भर्नुहोस्</h3>
                        <h3 class="text-sm text-gray-400">कामदार खोज्नुहोस् </h3>
                        <h3 class="text-sm text-gray-400">सम्पर्क</h3>
                    </div>
                    <div class="">
                        <h2 class="text-lg">सम्पर्क</h2>
                        <h3 class="text-sm mt-2 text-gray-400">फोन:</h3>
                        <h3 class="text-sm text-gray-200">०१-४१०६५४०</h3>
                        <h3 class="text-sm text-gray-400">इमेल:</h3>
                        <h3 class="text-sm text-gray-200">info@rojgari.com</h3>
                        <h3 class="text-sm text-gray-400">मुख्य कार्यालय:</h3>
                        <h3 class="text-sm text-gray-200">मिन भवन मेन रोड, </h3>
                        <h3 class="text-sm text-gray-200">शान्तिनगर गेट संगै, </h3>
                        <h3 class="text-sm text-gray-200">काठमाडौँ, नेपाल</h3>
                    </div>
                </div>
      </div>
      <div class="py-4 text-sm">
        <h2>२०२० - रोजगारी
        </h2>
      </div>
  </footer>
</template>

<script>
export default {

}
</script>

<style>

</style>